
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/web-viewer-for-instagram",
      function () {
        return require("private-next-pages/web-viewer-for-instagram/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/web-viewer-for-instagram"])
      });
    }
  